// Core
import React, { FC } from 'react';
import { createPortal } from 'react-dom';
// Parts
import Table, { TableApiParamsType, TableHashCacheType } from "../../../components/Table";
// Engine
import { axiosAPI } from "../../../../engine/config/axios";
// Config

const MailTemplates:FC<TableHashCacheType> = (props) => {
  const { hashCache } = props;

  const gridParams = {
    grids: [{ name: 'mailTemplates', hashCache }],
  }

  const apiParams: TableApiParamsType = (loadOptions, pageParams) => ({
      filters: loadOptions?.filter,
      sort: loadOptions?.sort,
      ...pageParams
    });

  return <Table
    keyExpr="id"
    api={axiosAPI.settings.mailTemplates.table}
    apiParams={apiParams}
    gridParams={gridParams}
    gridName="mailTemplates"
    sortingMode="multiple"
  />;
}

function MailTemplatesPortal({ id }: { id: string }) {
  const Root = document.getElementById(id);
  return Root ? createPortal(<MailTemplates hashCache={Root?.dataset.hashCache} />, Root) : null;
}

export default MailTemplatesPortal;
